import {AdRComparison, AdRequestParams, AdRPeriod} from '../interfaces/ad-reports';

export class AdRReportParamsComparison implements AdRComparison {
  public on =     null;
  public value =  null;
}

export class AdRRequestParams implements Partial<AdRequestParams> {
  public column_state = null;
  public metrics = [];
  public dimensions = [];
  public metric_orders = [];
  public metric_filters = [];
  public dimension_orders = [];
  public dimension_filters = [];
  public filters = {};
  public period = {} as AdRPeriod;
  public compare = new AdRReportParamsComparison();
  public limit = 0;
  public page = 0;
}
